/**
 * Escape closes the thing on top — and nothing underneath it.
 *
 * The planner and the 3D workspace each listen for Escape on `window` (bubble
 * phase) to step their own state back. A modal or menu over them registers
 * here in the CAPTURE phase and stops the event, so one press closes the
 * modal only; the views never see it.
 */

import { useEffect, useRef } from 'react';

export function useEscape(active: boolean, handler: () => void): void {
  const handlerRef = useRef(handler);
  handlerRef.current = handler;
  useEffect(() => {
    if (!active) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key !== 'Escape') return;
      e.stopPropagation();
      e.preventDefault();
      handlerRef.current();
    };
    window.addEventListener('keydown', onKey, true);
    return () => window.removeEventListener('keydown', onKey, true);
  }, [active]);
}
